import { z } from "zod";
import { workflowExecutionEnvironmentSchema } from "./workflow-execution.js";
import { workflowEffectSchema } from "./workflow-resources.js";
const key = z.string().regex(/^[A-Za-z_][A-Za-z0-9_]{0,63}$/u);
export const workflowDryRunFixtureSchema = z.object({
    schemaVersion: z.literal(1), label: z.string().trim().min(1).max(160),
    evaluatedAt: z.number().int().positive(), environment: workflowExecutionEnvironmentSchema,
    item: z.record(z.string(), z.json()),
    invocations: z.array(z.object({
        nodeId: key,
        /** Absent for JEV; otherwise the exact declared effect key. */
        effectKey: key.optional(),
        /** A separate review decision for a waiting proposal; requires effectKey. */
        stage: z.literal("review").optional(), request: z.json(), simulatedResponse: z.json(),
    }).strict()).max(256),
}).strict().superRefine((value, ctx) => {
    if (new TextEncoder().encode(JSON.stringify(value)).length > 262_144)
        ctx.addIssue({ code: "custom", message: "A dry-run fixture must fit within 256 KiB." });
    if (value.invocations.some(entry => entry.stage === "review" && !entry.effectKey))
        ctx.addIssue({ code: "custom", message: "A review decision requires the proposal effect key." });
    const identities = value.invocations.map(entry => `${entry.nodeId}:${entry.effectKey ?? "judgment"}:${entry.stage ?? "invocation"}`);
    if (new Set(identities).size !== identities.length)
        ctx.addIssue({ code: "custom", message: "Provide one response per node and effect." });
});
export const workflowProposedEffectSchema = z.object({ nodeId: key,
    effect: workflowEffectSchema, payload: z.json(), simulatedResponse: z.json(),
}).strict();
export const workflowDryRunReceiptSchema = z.object({
    fixtureHash: z.string().regex(/^[0-9a-f]{64}$/u), fixture: workflowDryRunFixtureSchema,
    outcome: z.enum(["succeeded", "failed", "waiting_review", "waiting_posting", "rejected"]),
    proposedEffects: z.array(workflowProposedEffectSchema).max(256),
}).strict();
